export const GRID_AREA_NAME = 'name';
export const GRID_AREA_ARROW = 'arrow';
export const GRID_AREA_GROUP = 'class';

export const STUDENT_SECTION_TEST_ID = 'student-section';
